export default __webpack_public_path__ + "2bfba02.png";